module.exports = __webpack_public_path__ + "static/logo-codepen-5a320decc85cc9ae73baf3250babe317.png";